function formatDate(dateString) {
    return `${dateString.substr(5, 2)}${dateString.substr(7, 3)}${dateString.substr(7, 1)}${dateString.substr(0, 4)}`;
}

function sanitizeVacationDates(stateData) {
    if (!stateData) return null;
    const sanitary = stateData;
    try {
        sanitary.forEach((vd, i) => {
            sanitary[i].id = vd.id;
            sanitary[i].name = vd.name;
            sanitary[i].start_date = formatDate(vd.start_date);
            sanitary[i].end_date = formatDate(vd.end_date);
        });
    } catch (err) {
        sanitary.id = stateData.id;
        sanitary.name = stateData.name;
        sanitary.start_date = formatDate(stateData.start_date);
        sanitary.end_date = formatDate(stateData.end_date);
        sanitary.range = stateData.range_readable;
    }
    if (sanitary.length === 0) return null;
    return sanitary;
}

// List from soonest to farthest into the future
function futureVacationDates(state) {
    if (!state) return null;
    const sanitary = [];
    try {
        state.forEach((vd) => {
            if (!vd.past) {
                sanitary.push(vd);
            }
        });
    } catch (err) {
        if (!state.past) {
            sanitary.push(state);
        }
    }
    if (sanitary.length === 0) return null;
    return sanitary;
}

// List from most recent to oldest
function pastVacationDates(state) {
    if (!state) return null;
    const sanitary = [];
    try {
        state.forEach((vd) => {
            if (vd.past) {
                sanitary.push(vd);
            }
        });
    } catch (err) {
        if (state.past) {
            sanitary.push(state);
        }
    }
    if (sanitary.length === 0) return null;
    return sanitary.reverse();
}

export default {
    vacationDates(state) {
        return sanitizeVacationDates(state.vacationDates);
    },
    futureVacationDates(state) {
        return futureVacationDates(state.vacationDates);
    },
    pastVacationDates(state) {
        return pastVacationDates(state.vacationDates);
    },
    error(state) {
        return state.error;
    }
};
